const getters = {
  key: state => state.position.key,
  keyWords: state => state.position.keyWords,
  category: state => state.position.category,
  kind: state => state.position.kind,
  list: state => state.position.list,
  searchList: state => state.position.searchList,
  details: state => state.position.details,
  userInfo: state => state.user.userInfo,
  resume: state => state.resume.resume,
  resumeList: state => state.resume.list,
  total: state => state.position.total,
  drafts: state => state.resume.drafts,
  currForm: state => state.resume.currForm,
  submitForm: state => state.resume.submitForm,
  resumeCon: state => state.resume.resumeCon
}
export default getters

